import React from 'react';
import { Spinner } from '@blueprintjs/core';

export const Loading = props => <Spinner intent="primary" {...props} />;

export default Loading;
